// src/pages/AccessDenied.js
import { useNavigate, useLocation } from "react-router-dom";

export default function AccessDenied() {
  const navigate = useNavigate();
  const location = useLocation();
  const from = location.state?.from?.pathname || "/dashboard";

  return (
    <div style={{ textAlign: "center", padding: 50 }}>
      <h1>❌ Access Denied</h1>
      <p>You do not have permission to view this page.</p>
      <button
        onClick={() => navigate(from)}
        style={{
          marginTop: 20,
          padding: "10px 20px",
          borderRadius: 6,
          border: "none",
          background: "#007bff",
          color: "#fff",
          cursor: "pointer",
        }}
      >
        Go Back
      </button>
    </div>
  );
}
